import { Helmet } from 'react-helmet';
import Pricing from 'src/features/Pricing';
import MainLayout from 'src/layouts';

const PricingPage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>All Plans</title>
      </Helmet>
      <Pricing />
    </MainLayout>
  );
};

export default PricingPage;
